const availabilityData = [
  {
    sqFt: '3,000-7,000',
    addresses: [
      {
        title: '757 S. ALAMEDA',
        floorplans: [
          {
            number: 210,
            // text: 'Furnished Suite',
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=yNaUZ72wmmF'
          },
          {
            number: 220,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=iTEcGau5r1m'
          },
          {
            number: 230,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=mf1x9WzEs66',
            lodPending: true
          },
          {
            number: 250,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=AFtXSDoVWCD',
          },
          {
            number: 260,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=1B9MBzUYek9',
          },
          {
            number: 270,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=My859jo5iuj',
            // ROWDTLA_suite_270_757.pdf has never been uploaded - the download
            // link 404s, so hide the icon until the LOD arrives
            lodPending: true
          },
          {
            number: 280,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=YJRXRYwt17S',
          },
          // {
          //   number: 290,
          //   address: 757,
          //   walkthrough: 'https://my.matterport.com/show/?m=NAtE1Nv5tvs',
          // },
          {
            number: 310,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=2rjYji9MPXT'
          },
          {
            number: 320,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=B1DH3stwUDq'
          },
          {
            number: 330,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=rnhJ5kWm4vU'
          },
          // Listed in the 15,000-35,000 section instead (18,091 RSF)
          // {
          //   number: 340,
          //   address: 757
          // },
          // {
          //   number: 345,
          //   address: 757,
          //   walkthrough: 'https://my.matterport.com/show/?m=jK8bS8brRDL',
          // },
          {
            number: 360,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=LtB7KMExjRj'
          },
          {
            number: 380,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=eFiRR4iXk5h'
          },
          {
            number: 390,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=CuKDEbKXaTn'
          },
          { alternateName: 'suite 420', number: 420, address: 757, walkthrough: 'https://my.matterport.com/show/?m=BTU2WqotQwq' },
          // { alternateName: 'suite 425', number: 400470, address: 757, walkthrough: 'https://my.matterport.com/show/?m=Jffm26GxWZx' },
          { alternateName: 'suite 430', number: 400470, address: 757, walkthrough: 'https://my.matterport.com/show/?m=ejXQzGkBKvi' },
          { alternateName: 'suite 450', number: 400470, address: 757, walkthrough: 'https://my.matterport.com/show/?m=Rh65xRczx7i' },
          // { alternateName: 'suite 460', number: 460, address: 757, walkthrough: 'https://my.matterport.com/show/?m=XgN94XgVC9w' },
          { alternateName: 'suite 470', number: 470, address: 757, walkthrough: 'https://my.matterport.com/show/?m=Uy93RnU1LgJ' },
          { alternateName: 'suite 520', number: 520, address: 757, walkthrough: 'https://my.matterport.com/show/?m=6LFeiSQoyTq' },
          // { alternateName: 'suite 525', number: 500570, address: 757, walkthrough: 'https://my.matterport.com/show/?m=bgdJndsZAKA' },
          { alternateName: 'suite 530', number: 530, address: 757, walkthrough: 'https://my.matterport.com/show/?m=ynqy1etYRwc' },
          { alternateName: 'suite 550', number: 550, address: 757, walkthrough: 'https://my.matterport.com/show/?m=5nZcVLZTwFn' }
          // { alternateName: 'suite 560', number: 560, address: 757, walkthrough: '' },
          // { alternateName: 'suite 570', number: 500570, address: 757, walkthrough: '' },
        ]
      },
      {
        title: '767 S. ALAMEDA',
        floorplans: [
          {
            number: 218,
            address: 767,
            walkthrough: 'https://my.matterport.com/show/?m=G1oxDLchnZS'
          },
          {
            number: 234,
            address: 767,
            walkthrough: 'https://my.matterport.com/show/?m=SLcWG3groBy'
          },
          // {
          //   number: 265,
          //   address: 767,
          // },
          {
            number: 290,
            address: 767,
            walkthrough: 'https://my.matterport.com/show/?m=rojxjvcs56s'
          },
          { number: 330, address: 767, walkthrough: 'https://my.matterport.com/show/?m=KBQvxvGEJKZ' },
          {
            number: 410,
            address: 767,
            walkthrough:
              'https://nam02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fmy.matterport.com%2Fshow%2F%3Fm%3DNpEegKT83mf&amp;data=02%7C01%7CMatt.Johnson%40am.jll.com%7Ca514d2fb8e3f44f1f14708d7a11f1389%7Cbfef2b06d2564f8ebd038d3687987063%7C0%7C0%7C637155027149615428&amp;sdata=5LBc4RIvdJsakcF%2BQ6J4LfmayXzGy11rb5OUXdUZ2rs%3D&amp;reserved=0',
          },
          {
            number: 418,
            address: 767,
            walkthrough:
              'https://nam02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fmy.matterport.com%2Fshow%2F%3Fm%3DDaCayWt2TuC&amp;data=02%7C01%7CMatt.Johnson%40am.jll.com%7Ca514d2fb8e3f44f1f14708d7a11f1389%7Cbfef2b06d2564f8ebd038d3687987063%7C0%7C0%7C637155027149615428&amp;sdata=9Q0QegqtGTbsa1K3IPGim35QEZXuk0H6ltN%2BoqwYmEc%3D&amp;reserved=0',
          },
          // { number: 434, address: 767, walkthrough: '' },
          // { number: 470, address: 767, walkthrough: '' }
          { number: 490, address: 767, walkthrough: 'https://my.matterport.com/show/?m=xucAtykqmLz' }
        ]
      }
      // {
      //   title: '1320 E 7th Street',
      //   floorplans: [
      //     {
      //       number: 240,
      //       address: 1320,
      //     },
      //   ],
      // },
    ]
  },
  {
    sqFt: '7,000-15,000',
    addresses: [
      {
        title: '757 S. ALAMEDA',
        floorplans: [
          {
            number: 200,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=4DToV1DD8vR'
          },
          {
            number: 240,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=m6fWEfsfPvZ'
          },
          {
            number: 300,
            address: 757,
            walkthrough: 'https://my.matterport.com/show/?m=5GUpFAtBicm'
          },
          // {
          //   number: 340,
          //   address: 757,
          //   // walkthrough: 'https://my.matterport.com/show/?m=eFiRR4iXk5h',
          // },
          // { alternateName: 'suite 440', number: 400470, address: 757, walkthrough: 'https://my.matterport.com/show/?m=fXmHwjDwEaz' },
          // { alternateName: 'suite 540', number: 540, address: 757, walkthrough: 'https://my.matterport.com/show/?m=wpRHWByJHX7' }
        ]
      },
      {
        title: '767 S. ALAMEDA',
        floorplans: [
          {
            number: 250,
            address: 767,
            walkthrough: 'https://my.matterport.com/show/?m=KFXuuST36hZ'
          }
          // {
          //   number: 360,
          //   address: 767,
          // },
        ]
      },
      {
        title: '1320 E 7th Street',
        floorplans: [
          {
            number: 260,
            address: 1320,
            walkthrough: 'https://my.matterport.com/show/?m=eVjrrejsvte'
          }
        ]
      }
    ]
  },
  {
    sqFt: '15,000-35,000',
    addresses: [
      {
        title: '757 S. ALAMEDA',
        floorplans: [
          { number: 340, address: 757, walkthrough: 'https://my.matterport.com/show/?m=6iVfMGm7X9s' },
          // { alternateName: 'suite 400', number: 400470, address: 757, walkthrough: '' },
          // { alternateName: 'suite 500', number: 500, address: 757, walkthrough: '' },
          // { alternateName: 'Fourth Floor', number: 450, address: 757, walkthrough: '' },
          // { alternateName: 'Fifth Floor', number: 550, address: 757, walkthrough: '' },
          // { alternateName: 'Sixth Floor', number: 650, address: 757, walkthrough: '' },
          // { number: 660, address: 757, walkthrough: '' }
        ]
      },
      // {
      //   title: '767 S. ALAMEDA',
      //   floorplans: [
      //     {
      //       number: 300,
      //       address: 767,
      //       walkthrough: 'https://my.matterport.com/show/?m=JXXaU9NusmJ',
      //     },
      //     {
      //       number: 450,
      //       address: 767,
      //       walkthrough: '',
      //     },
      //   ]
      // },
      {
        title: '1320 E 7th Street',
        floorplans: [
          {
            number: 200,
            address: 1320,
            walkthrough: 'https://my.matterport.com/show/?m=KUen2iLC28s'
          }
        ]
      }
    ]
  },
  {
    sqFt: '35,000-200,000',
    addresses: [
      // {
      //   title: '757 S. ALAMEDA',
      //   floorplans: [
      //     // { alternateName: 'Fourth Floor', number: 450, address: 757, walkthrough: '' },
      //     // { alternateName: 'Fifth Floor', number: 550, address: 757, walkthrough: '' },
      //     // { alternateName: 'Sixth Floor', number: 650, address: 757, walkthrough: '' },
      //   ],
      // },
      {
        title: '777 S. ALAMEDA',
        floorplans: [
          { alternateName: 'suite 300', number: 300, address: 777, walkthrough: '' }
        ]
      }
    ]
  }
]

export default availabilityData
